<template>
  <div>
    <section class="modal-menu   text-right" @click.self="closeModal()">
        <div class="content">

            <div class="d-flex align-items-baseline justify-content-between">
              <!-- <router-link to="/" class="mr-3"
                ><img
                  class="menu-logo"
                  style="max-width: 160px; width: 100px"
                  src="@/assets/images/logo.png"
                  alt="benedito"
              /></router-link> -->
              <h2>{{ title }}</h2>
              <button
                type="button"
                class="bg-none weight-bold ml-3 mt-2 pt-1 px-2 text-color-666 rounded"
                @click="closeModal()"
              >
                <CloseSvg width="24" />
              </button>
            </div>
            <div v-if="menu&&menu.length">

              <childrenMenu v-if="childMenu" :childMenuItem="childMenuItem" />
            
              <nav class="mt-5" v-else>
                <ul class="grid-menu">
                  <li v-for="item in menu[0].children" :key="item.id" class="item-menu">
                    <button
                      class="btn-menu card"
                      v-if="item.children.length"
                      @click="showChildMenu(item)"
                    >
                      <figure >
                        <img  :src="item?.icon?.url ?? ''" alt="" />
                      </figure>
                      <h3 class="title-card">
                        {{ item?.title ?? "" }}
                      </h3>
                    </button>
                    <template v-else>
                      <a
                        v-if="item.new_tab || item.link"
                        :target="item.new_tab ? '_blank' : '_self'"
                        :href="
                          $router.resolve(
                            findUrl(
                              item.linkable_type,
                              item.linkable_id,
                              item.slug,
                              item.link
                            )
                          ).href
                        "
                        @click="close"
                        class="w-100 link-menu card"
                      >
                        <figure >
                          <img  :src="item?.icon?.url ?? ''" alt="" />
                        </figure>
                        <h3 class="title-card">
                          {{ item?.title ?? "" }}
                        </h3>
                      </a>
                      <router-link
                        v-else
                        @click.native="close"
                        :to="
                          $router.resolve(
                            findUrl(
                              item.linkable_type,
                              item.linkable_id,
                              item.slug,
                              item.link
                            )
                          ).href
                        "
                        class="link-menu w-100 card"
                      >
                        <figure >
                          <img  :src="item?.icon?.url ?? ''" alt="" />
                        </figure>
                        <h3 class="title-card">
                          {{ item?.title ?? "" }}
                        </h3>
                      </router-link>
                    </template>
                  </li>
                </ul>
        
                <!-- <div v-for="item in menu" :key="item.id"  class="card">
                  <div class="card-header my-1 pr-3 d-flex justify-content-between" id="headingOne" >
                    <a
                        v-if="item.new_tab || item.link"
                        :target="item.new_tab ? '_blank' : '_self'"
                        :href="$router.resolve(findUrl(
                              item.linkable_type,
                              item.linkable_id,
                              item.slug, item.link)).href"
                        @click="close" class="d-flex my-auto text-color-444  font-weight-bold">
                      <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
                      {{item.title}} </a>
                    <router-link v-else @click.native="close"
                                 class="d-flex my-auto text-color-444  font-weight-bold"
                                 :to="$router.resolve(findUrl(item.linkable_type, item.linkable_id, item.slug, item.link)).href">
                      <span class="circle-list bg-color-theme rounded-circle mt-1 ml-3"></span>
                      {{item.title}}
                    </router-link>
                    <button v-show="item.children.length!=0" @click="(e) => rotateArrow(e.currentTarget)"
                            class="all-categories-side-btn with-event collapsed" type="button" data-toggle="collapse"
                            :data-target="'#mobileMenuChild'+item.id" aria-expanded="true" aria-controls="collapseOne" >
                      <svg
                          class="svg1"
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            stroke="#444"
                            stroke-width="3"
                            d="M16.2559 4.24279C16.5805 4.56431 16.5827 5.08555 16.2537 5.40707L11.3882 10.1717L11.3023 10.2451C10.9734 10.4897 10.5033 10.4642 10.2048 10.1684C10.043 10.0082 9.96049 9.79753 9.96049 9.58794C9.96049 9.37725 10.043 9.16546 10.207 9.00525L15.0724 4.2395L15.1584 4.16609C15.4873 3.92149 15.9573 3.94706 16.2559 4.24279ZM16.3291 18.6783C16.5802 19.001 16.5535 19.4636 16.256 19.7583C15.9303 20.0798 15.4005 20.0809 15.0725 19.7594L7.74651 12.5828L7.67131 12.4987C7.55732 12.3523 7.5 12.1766 7.5 12.0001C7.5 11.7905 7.58254 11.5798 7.74428 11.4196C8.06998 11.097 8.5998 11.0959 8.92773 11.4174L16.2538 18.594L16.3291 18.6783Z"
                        />
                      </svg>
                      <svg
                          class="svg2 d-none"
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M19 8.5L12 15.5L5 8.5"
                            stroke="#444"
                            stroke-width="4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                      </svg>
                    </button>
        
                  </div>
        
                  <div  v-show="item.children.length!=0" :id="'mobileMenuChild'+item.id" class="sub-all-categories-side-btn text-right collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body py-0">
                      <ul class="all-categories-sub-menu pr-3">
                        <li v-for="child in item.children" :key="child.id">
                          <div class="d-flex">
                            <a v-if="child.new_tab || child.link" @click="close" :target="child.new_tab ? '_blank' : '_self'"
                               :href="$router.resolve(findUrl(
                              child.linkable_type,
                              child.linkable_id,
                              child.slug, child.link)).href"
                            >{{child.title}}</a>
                            <router-link v-else @click.native="close"
                                         :target="child.new_tab ? '_blank' : '_self'"
                                         :to="findUrl(child.linkable_type,child.linkable_id, child.slug)">
                              {{child.title}}
                            </router-link>
                            <button v-show="child.children.length!=0" @click="(e) => rotateArrow(e.currentTarget)"
                                    class="all-categories-side-btn with-event collapsed" type="button" data-toggle="collapse"
                                    :data-target="'#mobileMenuChildChild'+child.id" aria-expanded="true" aria-controls="collapseOne" >
                              <svg
                                  class="svg1"
                                  width="15"
                                  height="15"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    stroke="#444"
                                    stroke-width="3"
                                    d="M16.2559 4.24279C16.5805 4.56431 16.5827 5.08555 16.2537 5.40707L11.3882 10.1717L11.3023 10.2451C10.9734 10.4897 10.5033 10.4642 10.2048 10.1684C10.043 10.0082 9.96049 9.79753 9.96049 9.58794C9.96049 9.37725 10.043 9.16546 10.207 9.00525L15.0724 4.2395L15.1584 4.16609C15.4873 3.92149 15.9573 3.94706 16.2559 4.24279ZM16.3291 18.6783C16.5802 19.001 16.5535 19.4636 16.256 19.7583C15.9303 20.0798 15.4005 20.0809 15.0725 19.7594L7.74651 12.5828L7.67131 12.4987C7.55732 12.3523 7.5 12.1766 7.5 12.0001C7.5 11.7905 7.58254 11.5798 7.74428 11.4196C8.06998 11.097 8.5998 11.0959 8.92773 11.4174L16.2538 18.594L16.3291 18.6783Z"
                                />
                              </svg>
                              <svg
                                  class="svg2 d-none"
                                  width="15"
                                  height="15"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                    d="M19 8.5L12 15.5L5 8.5"
                                    stroke="#444"
                                    stroke-width="4"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                          <div  v-show="child.children.length!=0" :id="'mobileMenuChildChild'+child.id" class="sub-all-categories-side-btn text-right collapse" aria-labelledby="headingOne">
                            <div class="card-body py-0">
                              <ul class="all-categories-sub-menu pr-3">
                                <li v-for="childChild in child.children" :key="childChild.id">
                                  <a v-if="childChild.new_tab || childChild.link" @click="close" :target="childChild.new_tab ? '_blank' : '_self'"
                                     :href="$router.resolve(findUrl(
                              childChild.linkable_type,
                              childChild.linkable_id,
                              childChild.slug, childChild.link)).href"
                                  >{{childChild.title}}</a>
                                  <router-link v-else @click.native="close"
                                               :target="childChild.new_tab ? '_blank' : '_self'"
                                               :to="findUrl(childChild.linkable_type,childChild.linkable_id, childChild.slug)">
                                    {{childChild.title}}
                                  </router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
        
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> -->
              </nav>
            </div>
        </div>
    </section>
    <!-- <div class="all-categories-resp" @click="allCategoriesToggle()"></div> -->
  </div>
</template>

<script>
import findUrl from "@/libraries/links/LinkResolver";
import CloseSvg from "@/components/svgs/CloseSvg";
import childrenMenu from "./children.vue";
export default {
  name: "RespMenuMobile",
  components: { CloseSvg ,childrenMenu},
  data() {
    return {
      childMenu: false,
      childMenuItem: null,
      title:"دسته بندی ها"
    };
  },
  props: {
    showMenuMobile: Boolean,
    },
  watch: {},
  methods: {
    showChildMenu(item) {
      this.childMenuItem = item;
      this.childMenu = true;
      this.title = item.title;
      console.log(this.childMenu,"this.childMenu");
      
    },
    closeModal(){
          this.$emit('closeMenuMobile')
    },
    // gotoCategoryAndClose(id, slug) {
    //   this.$router.push({
    //     name: "product.category",
    //     params: { category: id, slug: slug },
    //   });
    //   this.allCategoriesToggle();
    // },
    close() {
    //   setTimeout(() => {
    //     let hasClassClose = document
    //       .getElementById("all-categories")
    //       .classList.contains("all-categories-close");
    //     if (hasClassClose) {
    //       this.allCategoriesToggle();
    //     }
    //   }, 200);
    },
    findUrl,
    // allCategoriesToggle() {
    //   document
    //     .getElementById("all-categories")
    //     .classList.toggle("all-categories-close");
    //   let hasClassClose = document
    //     .getElementById("all-categories")
    //     .classList.contains("all-categories-close");
    //   let catSide = document.getElementsByClassName("all-categories-side")[0];
    //   let allCategoriesResp = document.querySelectorAll(
    //     ".all-categories-resp"
    //   )[0];

    //   // let wrapper = document.getElementsByClassName('wrapper')[0];
    //   if (hasClassClose) {
    //     window.addEventListener("popstate", this.checkBackButton);
    //     this.$router.push(this.$route.fullPath + "#resp-menu");
    //     catSide.style.right = "0px";
    //     allCategoriesResp.style.display = "block";
    //     // if(window.screen.width >= 1200){
    //     // wrapper.style.paddingRight="250px";
    //     // }
    //   } else {
    //     // if(window.screen.width >= 1200){
    //     //     wrapper.style.paddingRight="0";
    //     // }
    //     catSide.style.right = "-103%";
    //     allCategoriesResp.style.display = "none";
    //     this.$router
    //       .replace(this.$route.fullPath.replace("#resp-menu", ""))
    //       .catch((e) => {});
    //     window.removeEventListener("popstate", this.checkBackButton);
    //   }
    // },
    // rotateArrow(el) {
    //   el.children.forEach((child) => {
    //     if (child.classList.contains("d-none")) {
    //       child.classList.remove("d-none");
    //     } else {
    //       child.classList.add("d-none");
    //     }
    //   });
    // },
    checkBackButton() {
      this.allCategoriesToggle();
    },
  },
  mounted() {},
//   beforeDestroy() {
//     // window.removeEventListener("popstate", this.checkBackButton);
//   },
  computed: {
    // دریافت منو ها از ویو ایکس
    menu() {
      if (this.$store.getters["front/getHomeData"] == null) {
        return this.$store.getters["front/getHomeData"];
      } else {
        return this.$store.getters["front/getHomeData"].menu.header;
      }
    },
    // دریافت دسته بندی ها ازویوایکس
    // category() {
    //   if (this.$store.getters["front/getHomeData"] == null) {
    //     return this.$store.getters["front/getHomeData"];
    //   } else {
    //     return this.$store.getters["front/getHomeData"].categories;
    //   }
    // },
  },
};
</script>
<style scoped>

.modal-menu{
    width: 100vw;
    height: 100vh;
    background-color: #00000042;
    backdrop-filter: blur(5px);
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1050;
}
.content{
    width: 85%;
    background-color: #fff;
    height: 100%;
}
.grid-menu {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 0 8px 1rem;
  list-style-type: none;
}
.item-menu {
  width: 100%;
  border: 1px solid #d4d4d4;
  border-radius: 0.25rem;
  display: flex;
  background-color: #fff;
  overflow: hidden;
}
.title-card {
    font-size: 13px;
    color: #000;
}
figure{
    margin: 0;
}
.btn-menu,
.link-menu {
    background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.grid-menu .item-menu:last-child{
    grid-column: 1/2 span;
}
.btn-menu img,
.link-menu img{
   width: 60px;
}
.all-categories-side {
  width: 85%;
}
/*.all-categories-side .all-categories-side-btn {
  flex-grow: 100;
  justify-content: flex-end;
  display: flex;
}


.all-categories-sub-menu > li {
  margin-bottom: 11px;
}*/
</style>
